import { request } from './apiClient'

// User-facing stock-plan calls. No store import (project pattern).

export const fetchStockPlan = () => request('GET', '/v1/stock-plan/')

// With a projectId the search runs on the plan pinned on that project (the one
// its table was matched on); without, on the user's generic plan.
export const searchStock = (q, projectId = null) =>
  request(
    'GET',
    `/v1/stock-plan/search/?q=${encodeURIComponent(q)}` +
      (projectId ? `&project=${encodeURIComponent(projectId)}` : '')
  )

export const rematchProject = (projectId) =>
  request('POST', `/v1/projects/${projectId}/stock-match`)

export const pickStockItem = (projectId, index, stockItemId) =>
  request('PATCH', `/v1/projects/${projectId}/material/${index}/stock-item`, {
    stock_item_id: stockItemId,
  })

export const addMaterialLines = (projectId, body) =>
  request('POST', `/v1/projects/${projectId}/material`, body)

export const deleteMaterialLine = (projectId, lineId) =>
  request('DELETE', `/v1/projects/${projectId}/material/${lineId}`)

export const logMaterialEvents = (projectId, events) =>
  request('POST', `/v1/projects/${projectId}/material/events`, { events })

export const fetchStockPlanPreference = () => request('GET', '/v1/stock-plan/preference')

export const saveStockPlanPreference = (planId) =>
  request('PUT', '/v1/stock-plan/preference', { plan: planId })
